import React from "react";
import { Link } from "react-router-dom";
import MailingListSignup from "./MailingListSignup";

type MediaFooterProps = {
  alwaysBottom?: boolean;
};

// Two-column editorial footer: the mailing-list signup on the left, Get Help on
// the right, social icons anchored at the bottom left. Typography follows the
// product-page faces (--font-product-*) rather than the seasonal --font-display,
// so the footer stays visually consistent with the PDP year round.
//
// The Get Help column keeps every link it had. The reference crop shows only
// two of them, but Terms, Privacy Policy and "Your Privacy Choices" are there
// for legal/compliance reasons and dropping them isn't a visual decision.
const MediaFooter = ({ alwaysBottom }: MediaFooterProps) => {
  return (
    <footer
      className={`site-footer ${alwaysBottom ? "absolute bottom-0" : ""}`}
    >
      <div className="site-footer__inner">
        <MailingListSignup />

        <div className="site-footer__help">
          <h2 className="site-footer__heading">Get Help</h2>
          <ul className="site-footer__links">
            <li>
              <Link className="site-footer__link" to="/contact">
                Contact Us
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/returns">
                Returns and Exchanges
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/orders/cancel">
                Cancel or Return an Order
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/shipping">
                Shipping
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/size-guide">
                Size Guide
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/faq">
                FAQ
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/terms">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/privacy">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link className="site-footer__link" to="/privacy">
                Your Privacy Choices
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Social Media Icons */}
      <div className="site-footer__social">
        <a
          href="https://www.facebook.com/p/Americana-Company-61571753557774/"
          aria-label="Facebook"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://x.com/americanac65529"
          aria-label="Twitter"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href="https://www.instagram.com/americanaandcompany/"
          aria-label="Instagram"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.tiktok.com/@americanacompany"
          aria-label="TikTok"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-tiktok"></i>
        </a>
      </div>
    </footer>
  );
};

export default MediaFooter;
